<template>
  <p class="text-muted text-center"
     v-text="calculateOrdinalNumber(index, perPage, currentPage)"/>
</template>

<script>
  export default {
    props: {
      index: {
        type: Number,
        required: true,
      },
      currentPage: {
        type: Number,
        required: true,
      },
      perPage: {
        type: Number,
        required: true,
      },
    },
    methods: {
      calculateRowIndex(index, perPage, currentPage) {
        return index + (perPage * (currentPage - 1));
      },
      calculateOrdinalNumber(index, perPage, currentPage) {
        return this.calculateRowIndex(index, perPage, currentPage) + 1;
      },
    },
  };
</script>

<style scoped>

</style>
